import { Map } from 'immutable';

export class MemoryStorage {
    _data = Map({});

    /**
     * Length getter
     */
    get length(): number {
        return this._data.size;
    }

    /**
     * Get item from storage
     * @param key
     * @param defaultValue
     * @returns {*}
     */
    getItem(key: string, defaultValue?: any): any {
        return this.hasItem(key) ? this._data.get(key) : defaultValue;
    }

    /**
     * Set item into storage
     * @param key
     * @param value
     * @returns {MemoryStorage}
     */
    setItem(key: string, value: any): MemoryStorage {
        this._data = this._data.set(key, value);
        return this;
    }

    /**
     * Remove item from storage
     * @param key
     * @returns {MemoryStorage}
     */
    removeItem(key: string): MemoryStorage {
        this._data = this._data.remove(key);
        return this;
    }

    /**
     * Check if item exist into storage
     * @param key
     * @returns {boolean}
     */
    hasItem(key: string): boolean {
        return this._data.has(key);
    }

    /**
     * Clear storage
     * @returns {MemoryStorage}
     */
    clear(): MemoryStorage {
        this._data = this._data.clear();
        return this;
    }
}
